import React,{useState} from 'react'
import { Navigate } from 'react-router-dom';
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';
import MessageAdmin from '../../CmsComponents/MessagesAdmin';

import {useDispatch } from 'react-redux';
import {useSelector} from 'react-redux';




function MessageAdminPage() {
    
    
    const dispatch = useDispatch();

    const [isOpen,setIsOpen]= useState(false);
    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));
    let Auth = useSelector((state)=>state.auth);
    const logout = ()=>{
        dispatch({type: 'LOGOUT'});
        Navigate('/');
        setUser(null)
    }

    function HandleClicked() {
        setIsOpen(!isOpen);
        console.log(Auth.authData);
    }

    return (
            <div>
            
            <p>{}</p>
            { 
            
            user?<div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <MessageAdmin isOpen={isOpen} />
            </div>: <Navigate to='/auth' />
            
            
            }
        </div>
    )
}

export default MessageAdminPage;